import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackViewedCollection.meta';

export type UseTrackViewedCollectionParams = {
  collection_id: string;
  short_url_id: string;
};

export const useTrackViewedCollection = () => {
  const { track } = useAnalyticsUtilities();

  const trackViewedCollection = useCallback(
    (params: UseTrackViewedCollectionParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackViewedCollection };
};
